module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('article', {
    staticClass: "page"
  }, [_c('header', [_c('breadcrumb', {
    attrs: {
      "objects": _vm.breadObjects
    }
  }), _c('h1', {
    staticClass: "pageTitle"
  }, [_vm._v("404")])]), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "toHome"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'top'
      }
    }
  }, [_vm._v("トップへ戻る")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-202add15!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404/404.vue
// module id = 93
// module chunks = 1